var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.writeLayouts),function(writeLayout){return _c('curation-write-link',{key:`curation${writeLayout}`,attrs:{"writeLayout":writeLayout,"curationData":_vm.curationData,"itemData":_vm.itemData}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }